export const STOCK_METRICS_ITEM_TITLE_STYLE = {
  EMPTY: 'empty',
  NOT_EMPTY: 'notEmpty',
  LIMITED: 'limited'
};
